import React from 'react'
import { Checkbox } from '@common/material'
import { Box, Flex, Text } from '@fundamentals'
import { SiteBoxDocument } from '@core/entities/SiteBoxDocument'
import { Palette } from '@core/theme/color-palette-siteassist'
import useFolderPath from '@core/providers/useFolderPath'
import { FileTypeIcon } from './FileTypeIcon'

interface FileTreeItemProps {
  file: SiteBoxDocument
  pl?: number
  showPath?: boolean
  multiSelect: boolean
  selectedSiteBoxDocuments: Array<SiteBoxDocument>
  onSelectFile: (item: SiteBoxDocument) => void
}

export const FileTreeItem: React.FC<FileTreeItemProps> = ({
  file,
  pl = 1,
  showPath = false,
  multiSelect,
  selectedSiteBoxDocuments,
  onSelectFile,
}) => {
  const isSelected = selectedSiteBoxDocuments?.some((doc) => doc.id === file.id)
  const { pathText } = useFolderPath()
  const path = showPath ? pathText(file.folder?.pathFromRoot) : null
  const expirySuffix = file.documentIntelligence?.getExpirySelectorSuffix()
  const expiryColor =
    file.documentIntelligence?.getExpiryStatusTextColor() ?? 'text.secondary'

  return (
    <Box
      onClick={() => onSelectFile(file)}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        pl,
        pr: 1,
        py: 0.75,
        cursor: 'pointer',
        userSelect: 'none',
        backgroundColor: isSelected ? Palette.Violet[50] : 'white',
        '&:hover': {
          backgroundColor: Palette.Violet[100],
        },
      }}
    >
      <Flex alignItems='center'>
        {multiSelect && (
          <Checkbox
            size='small'
            checked={isSelected}
            onClick={(e) => {
              e.stopPropagation()
              onSelectFile(file)
            }}
          />
        )}
        <FileTypeIcon
          format={file.currentVersion?.format}
          sx={{ color: Palette.Grey[600], flexShrink: 0 }}
        />
        <Box ml={1}>
          <Text fontSize={14}>{file.name}</Text>
          {expirySuffix && (
            <Text fontSize={12} sx={{ color: expiryColor }}>
              {expirySuffix}
            </Text>
          )}
          {path && (
            <Text fontSize={12} sx={{ opacity: 0.6 }}>
              {path}
            </Text>
          )}
        </Box>
      </Flex>
    </Box>
  )
}
